import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import SmoothScroll from "./SmoothScroll";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import ServiceDetail from "./pages/ServiceDetail";
import ComingSoon from "./pages/ComingSoon";
import Legal from "./pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/leistungen/:slug" element={<ServiceDetail />} />
          <Route path="/software" element={<ComingSoon variant="software" />} />
          <Route path="/kundenportal" element={<ComingSoon variant="portal" />} />
          <Route path="/mitarbeiter-app" element={<ComingSoon variant="app" />} />
          <Route path="/datenschutz" element={<Legal variant="privacy" />} />
          <Route path="/impressum" element={<Legal variant="legal" />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
